// eslint-disable-next-line import/prefer-default-export
export const endpoint = () => 'https://мойегрн.рф' // test
// eslint-disable-next-line import/prefer-default-export
// export const endpoint = () => '' // prod
